import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import providers from '../helpers/providers-list.json' ;
import technologies from '../helpers/offer-technologies-list.json' ;
import infrastructureOperators from '../helpers/infrastructure-operators-list.json';

import { EligibilityProvider } from '../models/eligibility-provider';
import { EligibilityTechnology } from '../models/eligibility-technology';

@Injectable({
  providedIn: 'root',
})
export class TechnicalEligibilityApiService {
  private readonly PROVIDERS = providers;
  private readonly TECHNOLOGIES = technologies;
  private readonly INFRASTRUCTURE_OPERATORS = infrastructureOperators;

  constructor() {}

  // TODO: Rework when we get an endpoint to retrieve technologies and providers data

  getProviders(): Observable<EligibilityProvider[]> {
    return of(this.PROVIDERS);
  }

  getTechnologies(): Observable<EligibilityTechnology[]> {
    return of(this.TECHNOLOGIES);
  }

  getTechnologyDisplayedName(name: string): string {
    return this.TECHNOLOGIES.find((technology: EligibilityTechnology) => technology.name === name)?.displayedName || name;
  }

  getProviderDisplayedName(name: string): string {
    return this.PROVIDERS.find((provider: EligibilityProvider) => provider.name === name)?.displayedName || name;
  }

  getTechnologiesByType(type: string): EligibilityTechnology[] {
    return this.TECHNOLOGIES.filter((technology: EligibilityTechnology) => technology.type === type);
  }

  getTechnologyNamesByType(type: string): string[] {
    return this.getTechnologiesByType(type).map(technology => technology.name);
  }

  getProvidersByType(type: string): EligibilityProvider[] {
    return this.PROVIDERS.filter((provider: EligibilityProvider) => provider.type === type);
  }

  getInfrastructureOperatorByCode(code: string) {
    return this.INFRASTRUCTURE_OPERATORS.find((infrastructureOperator) => infrastructureOperator.code === code);
  }
}
